module.exports = __webpack_public_path__ + "img/v4.c0b54394.jpg";